/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.content-center {
  @apply justify-center text-center;
}

.content-left {
  @apply justify-start;
}

.content-right {
  @apply justify-end;
}
.tab-switcher-container {
  @apply flex  justify-start items-stretch gap-y-[16px] pl-24px;
}

.tab-switcher-wrapper {
  @apply w-full h-auto flex flex-col justify-start items-stretch gap-x-[8px] relative;
}

.tab-switcher-wrapper.container {
  @apply max-sm:pl-0;
}

.tab-switcher-wrapper.container .tab-switcher-top-title {
  @apply max-sm:px-16px;
}

.tab-switcher-wrapper .tab-switcher-tabs {
  @apply w-fit sm:w-full h-auto max-w-[35%] md:max-w-[30%] lg:max-w-[35%] flex flex-col justify-start items-start gap-y-[8px] relative z-20;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab {
  @apply w-[90%] sm:w-[98%] h-auto sm:pr-12px flex justify-start items-center bg-white gap-x-16px rounded-[12px] border-[1px] border-ui-gray-4 font-poppins fs-0 font-medium cursor-pointer transition-colors;
  transition: all 0.3s ease;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab:hover  {
  @apply !border-medium-blue;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab:hover .tab-switcher-tab-icon-wrapper .tab-switcher-tab-icon {
  @apply !bg-medium-blue ;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab.active:hover .tab-switcher-tab-icon-wrapper .tab-switcher-tab-icon {
  @apply !bg-white;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab.active {
  @apply bg-medium-blue border-medium-blue;
  width: calc(100% + 20px);
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab-icon-wrapper {
  @apply w-full h-full min-h-[86px] max-w-[86px] flex justify-center items-center bg-ui-gray-6 rounded-r-[10px] sm:rounded-r-[0px] sm:rounded-l-[10px] transition-colors ;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab-icon-title {
  @apply font-poppins fs-min font-medium hidden sm:block sm:py-8px;
  transition: all 0.3s ease;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab.active .tab-switcher-tab-icon-title {
  @apply !text-white;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab.active .tab-switcher-tab-icon-wrapper{
  @apply bg-medium-blue text-white;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab-icon-wrapper .tab-switcher-tab-icon {
  @apply w-[48px] h-[48px];
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  background-color: black;
  transition: all 0.3s ease;
}

.tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab.active .tab-switcher-tab-icon-wrapper .tab-switcher-tab-icon {
  @apply bg-white transition-colors;
}

.tab-switcher-wrapper .tab-switcher-slide {
  @apply w-full h-auto sm:max-w-[65%] md:max-w-[70%] lg:max-w-[65%] bg-ui-gray-6 flex flex-col md:flex-row justify-start items-stretch rounded-[12px] overflow-hidden relative z-10;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-content {
  @apply w-full h-auto md:max-w-[50%] flex flex-col justify-center gap-y-[16px]  pl-48px pr-24px md:px-[50px] py-24px; 
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-content .tab-switcher-slide-content-icon-title-mobile {
  @apply block sm:hidden font-poppins fs-1 font-medium text-medium-blue;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-content .tab-switcher-slide-content-title {
  @apply font-poppins fs-3 font-semibold text-ui-gray-1;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-content .tab-switcher-slide-content-description {
  @apply font-poppins fs-2  font-normal text-ui-gray-2;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-content .tab-switcher-slide-content-description a {
  @apply text-medium-blue hover:text-dark-blue transition-colors underline;
}


.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-content .tab-switcher-slide-content-description p {
  @apply mb-8px;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-content .tab-switcher-slide-content-buttons {
  @apply flex gap-12px h-40px;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper {
  @apply w-full h-auto md:max-w-[50%] aspect-square;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper .tab-switcher-slide-asset {
  @apply w-full h-full object-cover;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper .tab-switcher-slide-video {
  @apply w-full h-auto rounded-[12px] md:rounded-l-[0px] hidden;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper .tab-switcher-slide-video .plyr {
  @apply !rounded-[12px] md:!rounded-l-[0px];
  background: transparent !important;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper .tab-switcher-slide-video .plyr__video-wrapper {
  @apply !rounded-[12px] md:!rounded-l-[0px];
  background: transparent !important;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper .tab-switcher-slide-video .plyr__controls {
  @apply !hidden;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper.video-active .tab-switcher-slide-asset {
  @apply hidden;
}

.tab-switcher-wrapper .tab-switcher-slide .tab-switcher-slide-asset-wrapper.video-active .tab-switcher-slide-video {
  @apply block;
}

@media(max-width: 767px) {
  .tab-switcher-container {
    @apply !pl-0;
  }
  .tab-switcher-wrapper .tab-switcher-tabs .tab-switcher-tab {
    @apply !rounded-l-[0px];
  }
} 

/* Tab Animations */

.tab-switcher-slide-content{
  opacity: 1;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
}

.tab-switcher-slide-asset-wrapper {
  animation-duration: 0.45s;
}
/* .tab-switcher-slide-content.active,
.tab-switcher-slide-asset-wrapper.active {
  opacity:1;
} */
.tab-switcher-slide-content.animate-in,
.tab-switcher-slide-asset-wrapper.animate-in {
  animation-name: slide-fade-in;
}

.tab-switcher-slide-content.animate-out,
.tab-switcher-slide-asset-wrapper.animate-out {
  animation-name: slide-fade-out;
}

@keyframes slide-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes slide-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* Animation */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2, .overlay3, .overlay4, .overlay5, .overlay6{
  @apply bg-white absolute w-full h-full top-0 left-0 z-30 opacity-50;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.tab-switcher-wrapper.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: .15s;
  }
  

